'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.element = undefined;

var _elementConstants = require('./elementConstants');

var TYPES = _interopRequireWildcard(_elementConstants);

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _elementRegistry = require('./elementRegistry');

var elementFactory = _interopRequireWildcard(_elementRegistry);

var _elementReducerAttachments = require('./elementReducerAttachments');

var _elementReducerAttachments2 = _interopRequireDefault(_elementReducerAttachments);

var _elementReducerIcons = require('./elementReducerIcons');

var _elementReducerIcons2 = _interopRequireDefault(_elementReducerIcons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = Immutable.Map();

var createElement = function createElement(state, action) {
    return Immutable.fromJS(elementFactory.createElementObject(action));
};

var shareElement = function shareElement(state, action) {
    var acl = state.get('acl') || Immutable.Map();
    acl = acl.set(action.userId, action.permissions);
    return state.set('acl', acl);
};

var unshareElement = function unshareElement(state, action) {
    var acl = state.get('acl') || Immutable.Map();
    acl = acl.delete(action.userId);
    return state.set('acl', acl);
};

var applyChangesToElement = function applyChangesToElement(state, _ref, changes) {
    var modified = _ref.modified;
    return state.update('content', function (content) {
        return content.merge(Immutable.fromJS(changes));
    }).setIn(['meta', 'modifiedTime'], modified);
};

var updateElement = function updateElement(state, action) {
    var id = state.get('id');
    var update = action.updates.filter(function (updateEntry) {
        return updateEntry.id === id;
    })[0];
    return applyChangesToElement(state, action, update.changes);
};

var applyMoveToElement = function applyMoveToElement(state, _ref2, location) {
    var modified = _ref2.modified;

    if (!location.parentId || !location.section || !location.position) return state;
    if (location.parentId === state.get('id')) return state;

    return state.set('location', Immutable.fromJS(location)).setIn(['meta', 'modifiedTime'], modified);
};

var multiMoveElement = function multiMoveElement(state, action) {
    var id = state.get('id');
    var move = action.moves.filter(function (moveEntry) {
        return moveEntry.id === id;
    })[0];
    return applyMoveToElement(state, action, move.location);
};

var moveAndUpdateElement = function moveAndUpdateElement(state, action) {
    return state.withMutations(function (mutableState) {
        applyMoveToElement(mutableState, action, action.location);
        applyChangesToElement(mutableState, action, action.changes);
    });
};

var setElementType = function setElementType(state, action) {
    return state.set('elementType', action.elementType);
};

/**
 * Element Reducer.
 * Handles actions for individual elements.
 * This is always delegated to by the elementsReducer (it is not part of the reducer hierarchy created using
 * 'combineReducers').
 *
 * @param state {Element Object} The element that needs to respond to the action.
 * @param action {Object} The redux action to respond to.
 *
 * @returns {Object} The new state of the element.
 */
var element = exports.element = function element() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case TYPES.ELEMENT_SHARE:
            return shareElement(state, action);
        case TYPES.ELEMENT_UNSHARE:
            return unshareElement(state, action);
        case TYPES.ELEMENT_CREATE:
            return createElement(state, action);
        case TYPES.ELEMENT_MOVE_MULTI:
            return multiMoveElement(state, action);
        case TYPES.ELEMENT_UPDATE:
            return updateElement(state, action);
        case TYPES.ELEMENT_SET_TYPE:
            return setElementType(state, action);
        case TYPES.ELEMENT_MOVE_AND_UPDATE:
            return moveAndUpdateElement(state, action);
        // Attachment uploads
        case TYPES.ELEMENT_ATTACHMENT_UPLOADING:
        case TYPES.ELEMENT_ATTACHMENT_UPLOAD_COMPLETED:
        case TYPES.ELEMENT_ATTACHMENT_CLEAN:
        case TYPES.ELEMENT_ATTACHMENT_DATA_READY:
        case TYPES.ELEMENT_ATTACHMENT_UPLOAD_PROGRESSED:
        case TYPES.ELEMENT_ATTACHMENT_UPLOAD_ERROR:
        case TYPES.ELEMENT_ATTACHMENT_CLEAR_ERROR:
            return (0, _elementReducerAttachments2.default)(state, action);
        case TYPES.ELEMENT_ICON_FIND:
        case TYPES.ELEMENT_ICON_FIND_SUCCESS:
        case TYPES.ELEMENT_ICON_FIND_FAILURE:
        case TYPES.ELEMENT_ICON_SEARCH:
            return (0, _elementReducerIcons2.default)(state, action);
        // On socket disconnection mark every element as stale so it will be re-fetched
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/common/elements/elementReducer.js
// module id = 2266
// module chunks = 0